import { LoadingButton } from "./loadingButton";
import { delay } from "./utils";
export function initializePwnedPasswordsSearch() {
    // Password checking functionality
    const passwordForm = document.getElementById("passwordForm");
    if (passwordForm) {
        const passwordInput = document.getElementById("passwordInput");
        const checkButton = document.getElementById("checkButton");
        const goodResult = document.getElementById("pwned-result-good");
        const badResult = document.getElementById("pwned-result-bad");
        const occurrenceCount = document.getElementById("occurrence-count");
        // Hide results initially
        goodResult.bootstrapHide();
        badResult.bootstrapHide();
        // Handle form submissions (Enter key)
        passwordForm.addEventListener("submit", async (e) => {
            e.preventDefault();
            await handlePasswordCheck();
        });
        // Handle direct button clicks
        checkButton.addEventListener("click", async (e) => {
            e.preventDefault();
            await handlePasswordCheck();
        });
        // Function to handle password checking
        async function handlePasswordCheck() {
            const password = passwordInput.value.trim();
            if (!password) {
                // Empty password, don't do anything
                return;
            }
            // Manually trigger the loading state
            if (!checkButton.loadingButton) {
                // Initialize if not already done
                checkButton.loadingButton = new LoadingButton(checkButton, {
                    loadingClass: "is-loading",
                    disableButton: true,
                    resetAfter: 0,
                });
            }
            // Start loading animation
            checkButton.loadingButton.start();
            // Fade out any existing results
            goodResult.classList.add("fade-out");
            badResult.classList.add("fade-out");
            // Simulate API call
            const results = await Promise.all([checkPasswordSecurity(password), delay(200)]);
            const prevalence = results[0];
            // Stop loading animation
            if (checkButton.loadingButton) {
                checkButton.loadingButton.stop();
            }
            if (prevalence > 0) {
                showPwnedResult(prevalence);
            }
            else {
                showSafeResult();
            }
            passwordInput.select();
            function showPwnedResult(count) {
                goodResult.bootstrapHide();
                badResult.bootstrapShow();
                badResult.classList.remove("fade-out");
                // Format the count with commas
                occurrenceCount.textContent = count.toLocaleString();
                // Scroll to results
                badResult.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            function showSafeResult() {
                badResult.bootstrapHide();
                goodResult.bootstrapShow();
                goodResult.classList.remove("fade-out");
                // Scroll to results
                goodResult.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }
}
async function checkPasswordSecurity(password) {
    const passwordHash = await Array.from(new Uint8Array(await crypto.subtle.digest("SHA-1", new TextEncoder().encode(password))), (byte) => byte.toString(16).padStart(2, "0")).join("");
    const pwnedResults = await Promise.all([fetch(`https://api.pwnedpasswords.com/range/${passwordHash.substring(0, 5)}`), delay(100 + Math.random() * 200)]);
    const pwnedResult = pwnedResults[0];
    const resultArray = (await pwnedResult.text()).split(/\r?\n/);
    const suffix = passwordHash.substring(5).toUpperCase();
    for (let i = 0; i < resultArray.length; i++) {
        const item = resultArray[i];
        if (item.startsWith(suffix)) {
            return Number.parseInt(item.split(":")[1]);
        }
    }
    return 0;
}
